import { Routes } from '@angular/router';
import { UserDashboardComponent } from './user/component/dashboard/dashboard.component';
import { AdminDashboardComponent } from './admin/components/admindashboard/dashboard.component';
import { SectionComponent } from './user/component/section/section.component';
import { DisplayrulesComponent } from './admin/components/displayrules/displayrules.component';
import { RulesComponent } from '../app/admin/components/rules/rules.component';
import { HomePageComponent } from './Common/home-page/home-page.component';
import { LoginRegisterComponent } from './login-register/login-register.component';
import { SetConfigurationsComponent } from './admin/components/set-configurations/set-configurations.component';
import { authGuard } from './Guard/auth.guard';
import { AbandonRuleComponent } from './admin/components/abandon-rule/abandon-rule.component';
import { ProfileComponent } from './profile/profile.component';

export const routes: Routes = [
    {path:"",component:HomePageComponent},
    { path: "admin", loadComponent: () => AdminDashboardComponent , canActivate:[authGuard] },
    { path: "addcontent", component: RulesComponent, canActivate:[authGuard] },
    { path: "login", component: LoginRegisterComponent ,canActivate:[authGuard]},
    { path: "profile", component: ProfileComponent,canActivate:[authGuard]},
    { path: "admin/section/:id", component: DisplayrulesComponent ,canActivate:[authGuard]},
    { path: "admin/section/:id/:div", component: AbandonRuleComponent ,canActivate:[authGuard]},
    { path: "user",loadComponent: () => UserDashboardComponent},
    { path: "user/section/:id", component: SectionComponent ,canActivate:[authGuard]},
    { path: "user/section/:id/:div", component: SectionComponent, canActivate:[authGuard]},
    { path: "configurations", component: SetConfigurationsComponent, canActivate:[authGuard]},
];
